module.exports = __webpack_public_path__ + "static/img/154_TO8_1873_og.ec55e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/154_TO8_1873_og.jpg
// module id = wn4z
// module chunks = 0